// extracted by mini-css-extract-plugin
export default {"Trend":"Trend-module__Trend__X_lpy","Up":"Trend-module__Up__DLk7d","Down":"Trend-module__Down__ERHWg"};